// 1. Converts poster tile prices (entered in AUD) into the visitor's active
//    Shopify Markets currency, using Shopify's native Shopify.currency.rate.
//    Only used as a fallback when no reference product is configured for a
//    block (the reference-product method is server-rendered and accurate,
//    so it never needs this).
// 2. Checks the free shipping / free gift threshold row using the already
//    server-computed, accurate live bundle price (from the reference
//    product) against the AUD thresholds, using the same rate for the
//    unit conversion. No manual AUD entry required for this comparison.
document.addEventListener('DOMContentLoaded', function () {
  var rate = null;
  var activeCurrency = null;

  if (window.Shopify && window.Shopify.currency) {
    var parsedRate = parseFloat(window.Shopify.currency.rate);
    if (parsedRate && !isNaN(parsedRate)) {
      rate = parsedRate;
      activeCurrency = window.Shopify.currency.active;
    }
  }

  convertFallbackPrices(rate, activeCurrency);
  updateThresholdRows(rate);
});

function convertFallbackPrices(rate, activeCurrency) {
  if (!rate || !activeCurrency) return;

  var elements = document.querySelectorAll('.collection-poster-tile__auto-price');
  if (!elements.length) return;

  var formatter;
  try {
    formatter = new Intl.NumberFormat(navigator.language || 'en', {
      style: 'currency',
      currency: activeCurrency,
      currencyDisplay: 'symbol',
    });
  } catch (e) {
    return;
  }

  elements.forEach(function (el) {
    var baseAmount = parseFloat(el.getAttribute('data-aud-amount'));
    if (isNaN(baseAmount)) return;

    el.textContent = formatter.format(baseAmount * rate);
  });
}

function updateThresholdRows(rate) {
  var rows = document.querySelectorAll('.collection-poster-tile__threshold-row');
  if (!rows.length) return;

  // A threshold comparison tolerates the small drift in the client-exposed
  // rate just fine (it's a yes/no unlock decision, not a displayed price),
  // so default to 1 (no conversion) if multi-currency isn't active, which
  // is correct for AUD-only visitors.
  var effectiveRate = rate || 1;

  rows.forEach(function (row) {
    var bundlePriceCents = parseFloat(row.getAttribute('data-bundle-price-cents'));
    if (isNaN(bundlePriceCents)) return;

    var shippingThresholdAud = parseFloat(row.getAttribute('data-free-shipping-threshold'));
    var giftThresholdAud = parseFloat(row.getAttribute('data-free-gift-threshold'));

    var shippingMet = false;
    var giftMet = false;

    if (!isNaN(shippingThresholdAud)) {
      var shippingThresholdCents = shippingThresholdAud * effectiveRate * 100;
      shippingMet = bundlePriceCents >= shippingThresholdCents;
    }

    if (!isNaN(giftThresholdAud)) {
      var giftThresholdCents = giftThresholdAud * effectiveRate * 100;
      giftMet = bundlePriceCents >= giftThresholdCents;
    }

    var textEl = row.querySelector('.collection-poster-tile__threshold-text');
    if (!textEl) return;

    if (shippingMet && giftMet) {
      textEl.textContent = '+ Free Shipping + Free Gift';
    } else if (shippingMet) {
      textEl.textContent = '+ Free Shipping';
    } else if (giftMet) {
      textEl.textContent = '+ Free Gift';
    } else {
      return; // neither met, leave hidden
    }

    row.style.display = 'flex';
  });
}